/* UpmySkin · comportements du thème (sans dépendance) */
(function () {
  'use strict';
  var R = (window.UMS && window.UMS.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Message éphémère ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Argent ---------- */
  function money(cents) {
    var fmt = (window.UMS && window.UMS.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    var noDec = comma.replace(/,00$/, '');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.split('.')[0])
              .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  /* ---------- Tiroirs (menu à gauche, panier à droite) ---------- */
  var lastFocus = null;
  function scrim() { return $('#Scrim'); }
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    $$('body > [id="' + id + '"]').forEach(function (x) { if (x !== d) x.remove(); });
    if (d.parentElement !== document.body) document.body.appendChild(d);
    closeDrawers(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (scrim()) scrim().hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(function () { var f = d.querySelector('button, a, input'); if (f) f.focus(); }, 50);
  }
  function closeDrawers(silent) {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (scrim()) scrim().hidden = true;
    document.body.classList.remove('is-locked');
    if (!silent && lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) {
      var target = o.getAttribute('data-drawer-open');
      if (target === 'CartDrawer' && window.UMS && window.UMS.cartDrawer === false) return;
      e.preventDefault(); openDrawer(target); return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.id === 'Scrim') { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeModals(); } });

  /* ---------- Panier (API Ajax Shopify + rendu de section) ---------- */
  function updateCartUI(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) cur.replaceWith(fresh);
    var count = fresh ? parseInt(fresh.getAttribute('data-count'), 10) || 0 : 0;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
  }
  function addToCart(form, button) {
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    return fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { toast(res.data.description || res.data.message || 'Ce produit n’a pas pu être ajouté.'); return; }
        updateCartUI(res.data.sections);
        if (window.UMS && window.UMS.cartDrawer === false) { toast('Ajouté au panier'); } else { openDrawer('CartDrawer'); }
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.disabled = false; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (!form.querySelector('[name="id"]') && !document.querySelector('[name="id"][form="' + form.id + '"]')) return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var body = { line: parseInt(b.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-qty'), 10)), sections: ['cart-drawer'], sections_url: window.location.pathname };
    b.disabled = true;
    fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.status) { toast(j.description || 'Quantité indisponible.'); } updateCartUI(j.sections); })
      .catch(function () { window.location.href = R.cart; });
  });

  /* ---------- Onglets génériques (résultats, FAQ) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tabs] [data-tab]');
    if (!t) return;
    var root = t.closest('[data-tabs]');
    var id = t.getAttribute('data-tab');
    $$('[data-tab]', root).forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
    $$('[data-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
  });

  /* ---------- Avant / après glissant ---------- */
  function initBA(root) {
    $$('[data-ba]', root).forEach(function (ba) {
      if (ba.__ba) return; ba.__ba = true;
      var r = ba.querySelector('input'), af = ba.querySelector('.ba__after'), h = ba.querySelector('.ba__handle');
      var up = function () { af.style.clipPath = 'inset(0 0 0 ' + r.value + '%)'; h.style.left = r.value + '%'; };
      r.addEventListener('input', up); up();
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    $$('[data-product-section]', root).forEach(function (sec) {
      if (sec.__pdp) return; sec.__pdp = true;
      var variants = [];
      try { variants = JSON.parse((sec.querySelector('[data-variants]') || {}).textContent || '[]'); } catch (e) {}
      var gal = sec.querySelector('[data-gallery]');
      var count = sec.querySelector('[data-gallery-count]');
      var thumbs = $$('[data-thumb]', sec);
      if (gal) {
        gal.addEventListener('scroll', function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth);
          thumbs.forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
          if (count) count.textContent = (i + 1) + ' / ' + gal.children.length;
        }, { passive: true });
        thumbs.forEach(function (b) {
          b.addEventListener('click', function () { gal.scrollTo({ left: gal.clientWidth * parseInt(b.getAttribute('data-thumb'), 10), behavior: 'smooth' }); });
        });
      }
      function setVariant(id) {
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        var now = sec.querySelector('[data-price-now]'), was = sec.querySelector('[data-price-was]'), save = sec.querySelector('[data-price-save]');
        if (now) now.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(v.compare_at_price); }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Économisez ' + money(v.compare_at_price - v.price); }
        $$('[data-btn-price]', sec).forEach(function (el) { el.textContent = money(v.price); });
        var sp = sec.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
        var btn = sec.querySelector('[data-add-btn]'); if (btn) btn.disabled = !v.available;
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-variant-input]', sec).forEach(function (inp) { inp.addEventListener('change', function () { setVariant(inp.value); }); });
      $$('[data-qty-step]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentElement.querySelector('[data-qty-input]'); if (!input) return;
          input.value = Math.max(1, Math.min(20, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)));
        });
      });
      var sticky = sec.querySelector('[data-sticky-atc]');
      var mainBtn = sec.querySelector('[data-add-btn]');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(mainBtn);
      }
      var sBtn = sec.querySelector('[data-sticky-submit]');
      if (sBtn) sBtn.addEventListener('click', function () {
        var f = document.getElementById(sBtn.getAttribute('data-sticky-submit'));
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      });
    });
  }

  /* ---------- Recommandations produit ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.__rec || !el.getAttribute('data-url')) return; el.__rec = true;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- Tri de collection ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (s) { var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); window.location.href = url.toString(); }
    var a = e.target.closest('[data-autosubmit]');
    if (a && a.form) a.form.submit();
  });

  /* ---------- Fenêtres (formulaire de rétractation) ---------- */
  function openModal(id) { var m = document.getElementById(id); if (!m) return; $$('body > [id="' + id + '"]').forEach(function (x) { if (x !== m) x.remove(); }); if (m.parentElement !== document.body) document.body.appendChild(m); m.hidden = false; document.body.classList.add('is-locked'); var f = m.querySelector('input:not([type="hidden"]), button'); if (f) f.focus(); }
  function closeModals() { $$('.modal').forEach(function (m) { m.hidden = true; }); if (!$('.drawer.is-open')) document.body.classList.remove('is-locked'); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) { e.preventDefault(); openModal(o.getAttribute('data-modal-open')); return; }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal')) closeModals();
  });
  function autoOpenModals() {
    $$('.modal [data-modal-autoopen]').forEach(function (el) { var m = el.closest('.modal'); if (m) openModal(m.id); });
  }

  /* ---------- Initialisation (et rechargement dans l’éditeur de thème) ---------- */
  function init(root) { initBA(root); initProduct(root); initRecommendations(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); autoOpenModals(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#MenuDrawer')) openDrawer('MenuDrawer');
  });
  document.addEventListener('shopify:section:deselect', function () { closeDrawers(true); });
})();
